import React from 'react'
import {makeStyles, Typography} from '@material-ui/core';
import PropTypes from 'prop-types';

const useStyle = makeStyles(theme => ({
    root: {
        marginBottom: theme.spacing(2)
    },
    italic: {
        fontStyle: 'italic'
    }
}))

function DemandValidationMessages(
    {
        section,
        editable
    }) {
    const classes = useStyle();
    const show = editable && section && (section.messages || section.infoMessages);
    return (show && <div className={classes.root}>
        {
            !!section?.messages && section.messages.map((x, i) => <Typography key={i} color="error">{x}</Typography>)
        }
        {
            !!section?.infoMessages && section.infoMessages.map((x, i) => <Typography key={i} color="primary" className={classes.italic}>{x}</Typography>)
        }
    </div>)
}

DemandValidationMessages.propTypes = {
    section: PropTypes.object,
    editable: PropTypes.bool,
}

export default DemandValidationMessages;